import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import QuizDetails from '../../Componetns/QuizDetails/QuizDetails';
import BackgroundAudio from '../../../Games/Componetns/BackgroundAudio/BackgroundAudio';
import classNames from 'classnames';

import './QuestionContainer.scss';

import { nextGamePage, returnGameList, setQuizResults } from '../../Actions/GamesActions';

const DEELAY = 1300;

class QuestionContainer extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);

    this.onAnswer = this.onAnswer.bind(this);

    this.state = {
      answered: false,
      current: 0,
      questionsNumber: props.quiz.questions.length,
      showResults: false,
      correct: true,
    };
  }

  onAnswer(answer) {
    const { isCorrect } = answer;
    const { current, questionsNumber } = this.state;
    console.log({ current });
    console.log({ questionsNumber });
    if (current >= questionsNumber - 1) {
      this.setState({ complete: true, answered: true, showResults: true, correct: isCorrect });

      setTimeout(() => {
        this.props.setQuizResults(isCorrect);
        this.props.nextGamePage(isCorrect);
        this.setState({ answered: false, correct: isCorrect, showResults: false });
      }, DEELAY);
    } else {
      this.setState({
        answered: true,
        correct: isCorrect,
        showResults: true,
      });
      setTimeout(() => {
        this.setState({
          current: this.state.current + 1,
          answered: false,
          showResults: false,
          correct: isCorrect,
        });
      }, DEELAY);
    }
  }

  render() {
    const { quiz, loading, game, isBackgroundPlaying } = this.props;
    const { answered, current, complete, showResults, correct, indexToShow } = this.state;
    const { sorting } = game;
    const { successes, fails, pipe, pipePosition, pipeRotate } = sorting;
    return (
      <div className="container question-container">
        {loading ? (
          <div>loading...</div>
        ) : (
          <QuizDetails {...quiz} current={current} answered={answered} onAnswerClick={this.onAnswer} />
        )}
        {showResults && (
          <div
            className={classNames('results', {
              correct: correct,
              incorrect: !correct,
            })}
          >
            <i className={correct ? 'ti-check ' : 'ti-close'} />
            <span>
              {correct
                ? successes && indexToShow > -1 && successes[indexToShow].text
                  ? successes[indexToShow].text
                  : ''
                : fails && indexToShow > -1 && fails[indexToShow].text
                ? fails[indexToShow].text
                : ''}{' '}
            </span>
          </div>
        )}
        {quiz.backgroundMusic && (
          <BackgroundAudio loop={quiz.backgroundMusic.repeat} music={quiz.backgroundMusic.src} isPlaying={true} />
        )}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    quiz: state.games.getIn(['active', 'current', 'quiz']).toJS() || {},
    loading: state.games.getIn(['active', 'loading']),
    game: state.games.getIn(['active', 'current']).toJS() || '',
  }),
  (dispatch) =>
    bindActionCreators(
      {
        nextGamePage,
        setQuizResults,
        returnGameList,
      },
      dispatch
    )
)(QuestionContainer);



// WEBPACK FOOTER //
// ./src/modules/Games/Containers/QuestionContainer/QuestionContainer.js